import { useState } from 'react';
import { API_URL, API_VERSION } from '@constants';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';
import { useData } from '@hooks/useData';

const ENDPOINT_URL = '/users/get-available-drivers';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export type AvailableDriversSuccessResponse = paths[url]['get']['responses']['200']['content']['application/json'];

export const useGetAllDrivers = () => {
    const { getHeaders, getCommonParameters, handleCommonErrors } = useApiConfig();

    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [success, setSuccess] = useState<string | null>(null);
    const [lastResponseTime, setLastResponseTime] = useState<Date | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
     const [validationErrors, setValidationErrors] = useState<any | null>(null);
    const { setAvailableDrivers } = useData();


    const request = async () => {
        setLoading(true);
        setSuccess(null);
        setError(null);
        setErrorMessage(null);
        setValidationErrors(null);

        try {
            const inputParameters = new URLSearchParams(getCommonParameters()).toString();
            const response = await fetch(`${API_URL}${ENDPOINT_URL}?${inputParameters}`, {
                method: 'GET',
                headers: getHeaders()
            });

            if (!response.ok) {
                const error = new Error() as ApiError;

                try {
                    const json = await response.json();
                    error.message = json.message;
                    error.errors = json.errors;
                    setError(error.message);
                } catch (error: any) {
                    error.message = '';
                }

                error.statusCode = response.status;
                throw error;
            }

            const data: AvailableDriversSuccessResponse = await response.json();
            setAvailableDrivers(data);

        } catch (error: any) {
            handleCommonErrors(error);
            error.message && setError(error.message);
            error.errors && setValidationErrors(error.errors);
            //error.errors(error.errors);
        } finally {
            setLoading(false);
            setLastResponseTime(new Date());
        }
    };

    return { request, loading, success, errorMessage, error, validationErrors, lastResponseTime };
};
